import React from 'react';
import { AgreementMetadata } from '../../../../models/AgreementMetadata';
import { Button } from '../../../core/button';
import FontAwesomeIcon from '../../../core/fa_icon';
import Popover from '../../../core/popover';
import { AgreementVisitList } from './AgreementVisitList';
import styles from './agreement_visits.module.scss';

type Props = {
  meta: AgreementMetadata;
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

/**
 * Able to show visits to an agreement.
 */
export const AgreementVisitsReferrer: React.FC<Props> = ({ meta, open, onOpen, onClose }) => {
  const hasVisits = meta?.visits?.length > 0;

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <div style={{ position: 'relative' }}>
        <Button
          weight="simple"
          disabled={!hasVisits}
          onClick={() => onOpen()}>
          <FontAwesomeIcon name="eye" />
          {
            hasVisits ? (
              <span className={styles.badge}>{meta.visits.length}</span>
            ) : null
          }
        </Button>
      </div>

      {
        hasVisits ? (
          <Popover
            open={open}
            onClose={() => onClose()}
            title={`Avtalet har öppnats ${meta.visits.length} ${meta.visits.length === 1 ? 'gång' : 'gånger'}`}
            className={styles.popover}>
            <AgreementVisitList visits={meta.visits} />
          </Popover>
        ) : null
      }
    </div>
  )
}